import { render, staticRenderFns } from "./Editstudentform.vue?vue&type=template&id=20f635ce&scoped=true&"
import script from "./Editstudentform.vue?vue&type=script&lang=js&"
export * from "./Editstudentform.vue?vue&type=script&lang=js&"
import style0 from "./Editstudentform.vue?vue&type=style&index=0&id=20f635ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f635ce",
  null
  
)

export default component.exports